import { createAsyncThunk } from '@reduxjs/toolkit'
import { Branch } from './typings'
import { ServiceConfig } from '../services/config'
import { get } from '../services/crud'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.branch}`

export const getBranchList = createAsyncThunk<
  Branch[],
  void,
  { rejectValue: string }
>('branches/all', async (_, thunkApi) => {
  const response = await get(`${baseUrl}`)

  if (response.ok) {
    const payload: ISearchResponse<Branch> = await response.json()
    return payload.items
  } else {
    const json = await response.json()
    return thunkApi.rejectWithValue(json)
  }
})

export const getBranchDetail = createAsyncThunk<Branch, string>(
  'branches/detail',
  async (id, thunkApi) => {
    const response = await get(`${baseUrl}/${id}`)

    if (response.ok) return await response.json()
    else {
      const json = await response.json()
      return thunkApi.rejectWithValue(json)
    }
  },
)
